<template>
    <div class="flex flex-col items-center pt-5">
        <div ref="header" class="text-center opacity-0 sm:opacity-100">
            <div
                class="mb-4 hidden sm:block"
                v-if="typeof questionImage != 'undefined' && questionImage !== null && questionImage !== ''"
            >
                <div class="w-32 h-32 md:w-32 md:h-32 mx-auto" v-if="!questionImage && questionImage === ''"></div>
                <ImageQuestion :path="questionImage" :size="'small'" class="mx-auto"></ImageQuestion>
            </div>
            <h1
                id="question-title"
                class="font-bold text-white text-center"
                style="display: none"
                :class="{ 'mb-6 md:mb-12 mt-0': !questionImage, 'mt-2 mb-4 md:mb-8': questionImage }"
            >
                {{ title }}
            </h1>
        </div>
        <div class="text-center pb-4 animated mt-6" :class="{ 'opacity-0': !isReadyToShow, fadeIn: isReadyToShow }">
            <div class="mx-auto" style="width: 100px; height: 100px">
                <ResultIconAnimation
                    v-if="isReadyToShow"
                    :is-correct="playerResult"
                    stroke="20"
                    strokeMark="23"
                    @alreadyShow="alreadyShowQuizResult"
                    @alreadyShowWrongAnimate="alreadyShowWrongAnimate"
                />
            </div>
            <h2
                class="theme-ui-text-color theme-question-shadow result-text text-center text-white font-size-30 font-bold uppercase mt-2 animated fadeIn"
                :class="{ 'mb-0': isShowCorrectButton }"
            >
                {{ playerResult ? $t('playlive_result_correct') : $t('playlive_result_wrong') }}!
            </h2>
            <div
                v-if="isShowCorrectButton"
                class="theme-ui-text-color uppercase font-size-15 font-opensans mb-3 text-white underline cursor-pointer p-3"
                ref="showCorrectBtn"
                @click.prevent="onClickShowCorrectAnswer"
            >
                {{ $t('playlive_result_show_correct') }}
            </div>
        </div>

        <div
            class="result-footer-container flex flex-col justify-center pb-5 animated"
            :class="{ 'opacity-0': !isReadyToShow, fadeIn: isReadyToShow }"
        >
            <div class="flex justify-center">
                <div class="text-center mr-20">
                    <i
                        class="theme-ui-text-color theme-question-shadow fas fa-check-circle text-white font-size-55"
                    ></i>
                    <p class="theme-ui-text-color theme-question-shadow text-white font-size-55 font-bold">
                        {{ playerCorrect }}
                    </p>
                </div>
                <div class="text-center">
                    <i
                        class="theme-ui-text-color theme-question-shadow fas fa-times-circle text-white font-size-55"
                    ></i>
                    <p class="theme-ui-text-color theme-question-shadow text-white font-size-55 font-bold">
                        {{ playerWrong }}
                    </p>
                </div>
            </div>

            <div class="text-center pt-5 animated" :class="{ 'opacity-0': isLastQuestion, fadeIn: !isLastQuestion }">
                <p class="theme-ui-text-color theme-question-shadow text-white font-size-20 font-bold">
                    {{ dynamicText.first }}
                </p>
                <p class="theme-ui-text-color theme-question-shadow text-white font-size-20 font-bold">
                    {{ dynamicText.secondary }}
                </p>
            </div>
        </div>
    </div>
</template>

<script>
import { mapState } from 'vuex'
import ImageQuestion from '@/components/ImageQuestion.vue'
import helper from '@/lib/helper.js'
import ResultIconAnimation from '@/components/ResultIconAnimation.vue'

export default {
    components: {
        ImageQuestion,
        ResultIconAnimation
    },

    props: {
        userType: String,
        title: String,
        correctAnswer: Array,
        results: Array,
        playerResult: {
            default: ''
        },
        showSummary: Boolean,
        showCorrectAnswer: {
            default: false
        },
        playerName: {
            type: String,
            default: ''
        },
        questionImage: String,
        questionPreviewSize: {
            type: String,
            default: 'large'
        },
        answersRequired: String,
        wrongAudio: Element,
        isLastQuestion: Boolean,
        isResized: Boolean,
        isShowCorrectButton: Boolean,
        userEffectMusic: {
            type: Boolean,
            default: true
        },
        currentQuizIndex: {}
    },

    data: function () {
        return {
            isShowCorrectAnswer: this.showCorrectAnswer,
            playerCorrect: 0,
            playerWrong: 0,
            isReadyToShow: false,

            dynamicText: {
                first: '',
                secondary: ''
            }
        }
    },

    compute: {
        ...mapState({
            showCorrectAnswerWhenWrong: state => state.player.quiz.show_correct_answer
        })
    },

    mounted: function () {
        this.$nextTick(() => {
            if (this.$props.title) {
                helper.quizFontSize('question-title', this.$props.title.length)
            }
        })
    },

    watch: {
        results(resultsValue) {
            this.playerCorrect = 0
            this.playerWrong = 0

            resultsValue = resultsValue.filter(e => e.questionIndex == this.currentQuizIndex)

            if (resultsValue.length > 0) {
                for (const player of resultsValue) {
                    if (player.result) {
                        this.playerCorrect++
                    } else {
                        this.playerWrong++
                    }
                }
            }

            this.getDynamicTextResult()
        },

        playerResult(val) {
            this.isReadyToShow = true

            if (!val) {
                if (this.userEffectMusic) {
                    this.wrongAudio.play()
                }
            }
        },

        isResized(val) {
            if (val) {
                this.getHeaderRect()
            }
        }
    },

    methods: {
        handleShowCorrectAnswer: function () {
            this.isShowCorrectAnswer = !this.isShowCorrectAnswer
        },

        getDynamicTextResult: function () {
            let playerCorrectList = []
            let myRank = -1
            let leadName = ''

            let name = []

            if (this.results.length > 0) {
                this.results.forEach(item => {
                    if (item.result) {
                        name.indexOf(item.name) == -1 ? name.push(item.name) : name
                        playerCorrectList.push(item)
                    }
                })
            }

            let sumData = {}
            let newArr = []

            name.forEach(function (name) {
                if (!sumData[name]) {
                    sumData[name] = {
                        name: name,
                        result: [],
                        timer: 0
                    }
                }
            })

            playerCorrectList.forEach(function (res) {
                sumData[res.name].result.push(res.result)
                sumData[res.name].timer += res.timer
            })

            for (var data in sumData) {
                newArr.push(sumData[data])
            }

            newArr.sort(function (a, b) {
                if (a.result.length < b.result.length) return 1
                if (a.result.length > b.result.length) return -1
                if (a.timer < b.timer) return -1
                if (a.timer > b.timer) return 1
            })

            if (newArr.length > 0) {
                myRank = newArr.findIndex(item => item.name === this.playerName)
                leadName = newArr[0].name

                var correctCount = 0

                if (sumData[this.playerName]) {
                    const playerResult = JSON.parse(JSON.stringify(sumData[this.playerName]))
                    correctCount = playerResult.result.length
                }

                switch (myRank) {
                    case 0:
                        this.dynamicText = {
                            first: this.playerResult ? this.$t('playlive_result_rank1_1') : undefined,
                            secondary: this.$t('playlive_result_rank1_2')
                        }
                        break

                    case 1:
                        this.dynamicText = {
                            first: this.playerResult ? this.$t('playlive_result_rank2_1') : undefined,
                            secondary: this.$t('playlive_result_rank2_2')
                        }
                        break

                    case 2:
                        this.dynamicText = {
                            first: this.playerResult ? this.$t('playlive_result_rank3_1') : undefined,
                            secondary: this.$t('playlive_result_rank3_2')
                        }
                        break

                    default:
                        if (myRank > 2 && correctCount >= 3) {
                            this.dynamicText = {
                                first: this.playerResult ? this.$t('playlive_result_more_rank2_1') : undefined,
                                secondary: this.$t('playlive_result_more_rank2_2')
                            }
                        } else {
                            let dynamicSuffle = [
                                { first: `${this.$t('playlive_result_less_rank2_1')}`, secondary: leadName },
                                { first: leadName, secondary: this.$t('playlive_result_less_rank2_2') }
                            ]

                            let randIndex = Math.floor(Math.random() * 2)

                            this.dynamicText = dynamicSuffle[randIndex]
                        }

                        break
                }
            }
        },

        alreadyShowQuizResult() {
            this.$nextTick(() => {
                setTimeout(() => {
                    window.dispatchEvent(new CustomEvent('componentAlready'))
                }, 200)
            })
        },

        getHeaderRect() {
            const rect = this.$refs.header.getBoundingClientRect()

            this.$emit('getHeaderRect', rect)
        },

        alreadyShowWrongAnimate() {
            this.$emit('alreadyShowWrongAnimate')
        },

        onClickShowCorrectAnswer() {
            this.$emit('onShowCorrectAnswer')
        }
    }
}
</script>

<style lang="scss" scoped>
.icon {
    font-size: 6rem;
}
.result-text {
    animation-delay: 0.5s;
    animation-duration: 0.3s;
}
.fa-times-circle,
.fa-check-circle {
    animation-delay: 0.2s;
}
.result-footer-container {
    animation-delay: 0.8s;
}
</style>
